export default {
  updateNews (state, newNews) {
    state.news = newNews
  }
}
